import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { publicationsApiRequest } from "../../../api";
import List from "./List";
import SeeMore from "../SeeMore";
import ResponseMessage from "../ResponseMessage";

const PaginatedList = ({ artistId, noResultsMessage, includeGroup }) => {
  const defaultQuery = {
    page: 1,
    artist: artistId,
    includeGroup: includeGroup,
  };
  const [publications, setPublications] = useState([]);
  const [totalPages, setTotalPages] = useState();
  const [query, setQuery] = useState(defaultQuery);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    function onSuccess(response) {
      if (response.records && response.records.length > 0) {
        setPublications((publications) => [
          ...publications,
          ...response.records,
        ]);
      }
      setTotalPages(response.pagination.totalPages);
      setIsLoading(false);
    }

    const fetchData = () => {
      setIsLoading(true);
      publicationsApiRequest(query, onSuccess);
    };

    fetchData();
  }, [query]);

  useEffect(() => {
    if (query.artist !== artistId) {
      setPublications([]);
      setQuery((query) => ({ ...query, page: 1, artist: artistId }));
    }
  }, [artistId, query.artist]);

  const handleSeeMore = (event) => {
    event.preventDefault();
    if (query.page !== totalPages) {
      setQuery((query) => ({ ...query, page: query.page + 1 }));
    }
  };

  const handleSearch = (selection) => {
    // handle clear event
    if (!selection) return setQuery({ page: 1 });

    if (query.artist !== selection.id) {
      setPublications([]);
      setQuery({ page: 1, artist: selection.id });
    }
  };

  return (
    <>
      {publications.length === 0 && !isLoading ? (
        <ResponseMessage message={noResultsMessage} />
      ) : (
        <List publications={publications} isLoading={isLoading} />
      )}
      {query.page < totalPages && (
        <SeeMore
          onClick={handleSeeMore}
          isLoading={isLoading}
          disabled={isLoading}
        />
      )}
    </>
  );
};

PaginatedList.propTypes = {
  artistId: PropTypes.number,
  includeGroup: PropTypes.bool,
  noResultsMessage: PropTypes.string,
};

export default PaginatedList;
